import { render, staticRenderFns } from "./ClaimsDeclarationsFilter.vue?vue&type=template&id=f652e678"
import script from "./ClaimsDeclarationsFilter.vue?vue&type=script&lang=ts"
export * from "./ClaimsDeclarationsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsDeclarationsFilter.vue?vue&type=style&index=0&id=f652e678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports